import type { Ssm5ConnectionStatus } from '../helpers/check-connection';

import { checkConnection } from '../helpers/check-connection';
import { useLookup } from './use-lookup';

/**
 * Whether a connection is still open on its Cloud Connector, as the backend last said.
 *
 * @param cloudConnectorId - the ID to check, or undefined to skip the check
 * @returns open, gone or unreachable once checked; undefined without an ID or while the check is in flight
 */
export function useConnectionStatus(cloudConnectorId: string | undefined): Ssm5ConnectionStatus | undefined {
    return useLookup(cloudConnectorId, checkConnection);
}
